module.exports = __webpack_public_path__ + "img/dark-mode-mobile.2100d49a.svg";